import { useTheme } from '@mui/material/styles';

import { Box, Card, Divider, Grid, Icon, Tooltip, Typography } from '@mui/material';
import CountUp from 'react-countup';
import { ChipStatus } from '../chip-status/ChipStatus';

interface IWidgetCardProps {
    icon: string;
    IconColor?: 'inherit' | 'disabled' | 'action' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined;
    fontSizeIcon?: string;
    label: any;
    value: number;
    description: string;
    children?: React.ReactNode;
}

export const WidgetCard: React.FC<IWidgetCardProps> = ({ icon, IconColor, label, value, description }) => {
    const theme = useTheme();

    return (
        <Card sx={{ cursor: 'pointer', display: 'flex', borderRadius: 1, overflow: 'visible', height: '8rem', width: '100%', mt: 2, p: 2, border: '1px solid', borderColor: 'divider', boxShadow: '0 6px 16px rgba(16, 24, 40, 0.06)' }}>
            <Grid container >
                <Grid item xs={3} md={3}>
                    <Card sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 1, width: '4rem', height: '4rem', minWidth: '4rem', marginTop: -4, background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`, boxShadow: '0 8px 20px rgba(16, 24, 40, 0.14)' }}>
                        <Box display='flex' >
                            <Icon fontSize='medium' color={IconColor ? IconColor : undefined}>{icon}</Icon>
                        </Box>
                    </Card>
                </Grid>
                <Grid item xs={9} md={9}>
                    <Box display='flex' flexDirection='column' width='100%' gap={1}>
                        <Box display='flex' justifyContent='flex-end'>
                            <ChipStatus
                                label={label}
                                value={label}
                            />
                        </Box>
                        <Box display='flex' justifyContent='flex-end'>
                            <Typography variant="h5" component="div">
                                <CountUp
                                    end={value}
                                    duration={2}
                                />
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12} md={12} pt={2} display='flex' flexDirection='row' gap={1}>
                    <Icon fontSize='small'>info_outlined</Icon>
                    <Tooltip title={description}>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom noWrap>
                            {description}
                        </Typography>
                    </Tooltip>
                </Grid>
            </Grid>
        </Card>
    );
};
